import {  RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue} from 'recoil';
import {
    useEffect,
    useState,
    useRef,
    useMemo
}  from 'react';
import { useAuthentication } from '../../Hooks';
import {
    CompaniaAtom,
    FUENTE_CASO,
    FUENTE_CUENTA,
    getComponentWithLoading,
    ReferidosAtom,
    SolicitudesAtom,
    StringHelper,
    TIPO_COMPONENTE
} from '../../Utils';
import PantallaView from '../../Componentes/PantallasView/ViewContainer/PantallaView';
import useMessage from '../../Hooks/useMessage';
import {MiCuentaEdit} from "./MiCuentaEdit";
import {Simplebar} from "../../Componentes";
import {Compania, ESTATUS_BLOQUEADO} from "../../Models/Compania";

let canvasFunc = () => {};

const MiCuentaSL = ({showLoading, hideLoading}) => {
    const { usuario } = useAuthentication();
    const ref = useRef(null);
    const childRef = useRef(null);
    const [compania, setCompania] = useState(undefined);
    const [companiaConfig, setCompaniaConfig] = useState({});
    const [canvasType, setCanvasType] = useState("Tarea");
    const [showCanvas, setShowCanvas] = useState(false);
    const {Warning} = useMessage();
    const [casos, setCasos] = useState([]);
    const consultaActualId = useRef();
    const [showModal, setShowModal] = useState(false);
    const [companiaState, setCompaniaState] = useRecoilState(CompaniaAtom)
    const [solcitudesState, setSolicitudesState] = useRecoilState(SolicitudesAtom)
    const [referidosState, setReferidosState] = useRecoilState(ReferidosAtom)
    const [listadoCasos, setListadoCasos] = useState('');
    const [listadoReferidos, setListadoReferidos] = useState('');
    const [showCuentaCanvas, setShowCuentaCanvas] = useState(false);
    
    useEffect(() => {
        if(usuario?.Compania){
            let compania = usuario.Compania;
            if(compania.Estatus === ESTATUS_BLOQUEADO){
                Warning({message: 'Esta compañía está Bloqueada. Para más información, comuníquese con la Administración.'})
            }
            setCompania(compania)
        }
    },[usuario])
    useEffect(() => {
        let listado = [];
        solcitudesState?.forEach((caso) => {
            caso?.forEach((currentCase) => {
                listado.push(`${currentCase.NombreCaso}`);
            });
        });
        setListadoCasos(listado.join(', '));
    }, [solcitudesState]);
    useEffect(() => {
        let listado = [];
        referidosState?.forEach((caso) => {
            listado.push(`${caso.Nombre}`)
        });
        setListadoReferidos(listado.join(', '));
    }, [referidosState]);
    const actualizarEntidades = () => {

    };

    const handleClick = () => {
        ref.current?.showLoading(true);
        childRef.current?.grabar();
        ref.current?.showLoading(false);
        setShowCuentaCanvas(false);
    };
    
    const editSimplebar = (
        <Simplebar
            ref={ref}
            size="xxl"
            backdrop={true}
            placement={"end"}
            portal={false}
            visible={showCuentaCanvas}
            setShow={(e) => {
                setShowCuentaCanvas(e);
            }}
            useLoading={true}
            title={`Editar Informacion`}
            btnLeft={{
                show: true,
                message: "Grabar",
                isComponent: true,
                size: "45px",
                height: "24px",
                with: "24px",
                iconName: "save",
                isCenter: true,
                func: handleClick,
            }}
            btnRight={{
                show: false,
                label: "Grabar",
                func: () => {},
            }}
        >
            <MiCuentaEdit
                ref={childRef}
                showLoading={() => ref.current?.showLoading(true)}
                hideLoading={() => ref.current?.showLoading(false)}
                idSec={usuario?.CompaniaId}
                esModal
            />
        </Simplebar>
    );
    
    const Editar = () => {
        setShowCuentaCanvas(true);
    };
    const Caso = () => {
        setCanvasType(FUENTE_CASO);
        setShowCanvas(true);
    };
    const createRightSections = () => {
        const sections = [];

        
        let solicitudes = []
        solcitudesState?.forEach((caso) => {
            caso?.forEach((currentCase) => {
                solicitudes.push(currentCase);
            });
        });
        sections.push({
            title: "Solicitudes",
            tipo: TIPO_COMPONENTE.CASOS,
            icon: "notes",
            iconSize: "25px",
            info: solicitudes,
            onClick: Caso,
        });

        return sections;
    };

    const createLeftSectionBodyConfigSectionDetails = () => {
        let details = []
        
        if(compania?.CantidadUsuarios > 0){
            details.push({
                titulo: 'Licencias ERP', informacion: compania?.CantidadUsuarios
            })
        }
        
        if(compania?.CantidadUsuariosCRM > 0){
            details.push({
                titulo: 'Licencias CRM', informacion: compania?.CantidadUsuariosCRM
            })           
        }
        
        let modAdicionales = {titulo : "Modulos Adicionales", informacion: ''}
        let modulos = []
        if(compania?.UsaNomina){
            modulos.push('RRHH')
        }
        if(compania?.Configuracion.UsaConsulta) {
            modulos.push('Consulta Médica')
        }
        if(compania?.UsaFactoring){
            modulos.push('Factoring')
        }
        if(modulos.length > 0){
            modAdicionales.informacion = modulos.join(", ");
            details.push(modAdicionales);
        }

        let dgii = {titulo : "Integraciones DGII", informacion: ''}
        if(compania?.UsaFacturacionElectronica){
            dgii.informacion += `Facturación Electrónica: ${compania?.TipoPlanECF}`
        }else if(compania?.Configuracion.UsaImpresoraFiscal){
            dgii.informacion += `Impresora Fiscal`
        }
        if(dgii.informacion !== ''){
            details.push(dgii);
        }
        
        let panelFirma = {titulo : 'Panel de Firma', informacion: ''}
        if(compania?.Configuracion.UsaModuloVisaNet){
            panelFirma.informacion += 'Visa Net'
        }else if (compania?.Configuracion.UsaModuloCardNet){
            panelFirma.informacion += 'CardNet'
        }else if (compania?.Configuracion.UsaModuloAzul){
            panelFirma.informacion += 'Azul'
        }
        if(panelFirma.informacion !== ''){
            details.push(panelFirma);
        }
        
        let comercionElectronico = {titulo: "Comercio Electronico", informacion: ''}
        if(compania?.UsaShopify){
            comercionElectronico.informacion += 'Shopify'
        }else if(compania?.UsaWooCommerce){
            comercionElectronico.informacion += 'Woo Commerce'
        }
        if(comercionElectronico.informacion !== ''){
            details.push(comercionElectronico);
        }
        
        if(compania?.UsaEnlacePago){
            details.push({titulo: 'Enlace de Pago', informacion : 'CardNet Webservice'})
        }
        
        let otrasConfig = { titulo : 'Otras Configuracions', informacion: ''}
        let config = []
        if(compania?.UsaCaja){
            config.push('Cierre de Caja')
        }
        if(compania?.UsaCentro){
            config.push('Centro de Costos')
        }
        if(config.length > 0){
            otrasConfig.informacion = config.join(", ")
            details.push(otrasConfig);
        }
        return details;
    }
    
    const Config = {
        LeftSectionHeader:{
            label: 'Mi Cuenta'
        },
        LeftSectionBody: {
            showImage: true,
            img64: compania?.Logo,
            icon: "id-card",
            title: compania?.Nombre,
            HEIGHT: "91vh",
            subTitleRenderer: () => {
                return (
                    <>
                        {compania?.RNC ? <p className="p-0 m-0">{compania?.RNC}</p> : ""}
                        {compania?.Codigo ? <p className="p-0 m-0">{compania?.Codigo}</p> : ""}
                        {compania?.TelefonoPrincipal ? (
                            <p className="p-0 m-0">
                                {StringHelper.formatPhoneNumber(compania?.TelefonoPrincipal)}{" "}
                                {compania?.ExtensionTelefonoPrincipal && (
                                    <>
                                        <strong>Ext.</strong>
                                        {compania?.ExtensionTelefonoPrincipal}
                                    </>
                                )}
                            </p>
                        ) : (
                            ""
                        )}
                        {compania?.TelefonoSecundario ? (
                            <p className="p-0 m-0">
                                {StringHelper.formatPhoneNumber(compania?.TelefonoSecundario)}{" "}
                                {compania?.ExtensionTelefonoSecundario && (
                                    <>
                                        <strong>Ext.</strong>
                                        {compania?.ExtensionTelefonoSecundario}
                                    </>
                                )}
                            </p>
                        ) : (
                            ""
                        )}
                        {compania?.Email ? (
                            <p className="p-0 m-0">
                                {compania?.Email.split(",")[0]}
                            </p>
                        ) : (
                            ""
                        )}
                    </>
                );
            },
            Editar: Editar,
            sections: [
                {
                    title: "Facturación de Servicio",
                    details: [
                        {titulo: 'Tipo de Comprobante', informacion: compania?.cliente?.Tipo},
                        {titulo: 'Tipo de Documento', informacion: compania?.cliente?.TipoDocumento},
                        {titulo: 'Documento', informacion: compania?.cliente?.Documento},
                        {titulo: 'Nombre', informacion: compania?.cliente?.Nombre},
                        {titulo: 'Teléfono Principal', informacion: compania?.cliente?.Telefono1},
                        {titulo: 'Email', informacion: compania?.cliente?.Email},
                    ],
                },
                {
                    title: "Estado de Cuenta",
                    details: [
                        { titulo: "Balance Pendiente", informacion: companiaState },
                    ],
                },
                {
                    title: "Configuracion",
                    details: createLeftSectionBodyConfigSectionDetails()
                },
                {
                    title: "Referidos",
                    details: [
                        { titulo: "", informacion: listadoReferidos },
                    ],
                },
                {
                    title: "Solicitudes",
                    details: [
                        { titulo: "", informacion: listadoCasos },
                    ],
                },
            ],
            actions: [
                {
                    label: "Solicitud",
                    icon: "notes",
                    Size: "35px",
                    IconSize: "20px",
                    onClick: Caso,
                }
            ],
        },
        RightSection: {
            showLoading: showLoading,
            hideLoading: hideLoading,
            Referencia: compania?.Id,
            Fuente: FUENTE_CUENTA,
            PanelCollapsable: { sections: createRightSections() },
            HEIGHT: "84vh",
        },
        CreationCanvas: {
            showCanvas: showCanvas,
            setShowCanvas: setShowCanvas,
            type: canvasType,
            fuente: FUENTE_CUENTA,
            referencia: compania?.Id || null,
            afterSave: canvasFunc,
            entidadNombre: compania?.Nombre,
            config: companiaConfig,
            cuentaList: useMemo(() => [compania]?.filter((x) => x?.Id), [compania]),
            refreshView: actualizarEntidades,
        },
    }
    
    return (
        <div className='bootstrapiso' >
            {showCuentaCanvas && editSimplebar}
            <PantallaView {...Config}></PantallaView>
        </div>
    )
}

export const MiCuenta = getComponentWithLoading(MiCuentaSL)